/* eslint-disable @typescript-eslint/no-explicit-any */
export const noOp = () => {
  return;
};
